import { useIntl } from 'react-intl';
import { Box, Button, paletteColors, Tooltip } from '@evaneos/b2b-ui';
import MarkEmailUnread from '@evaneos/b2b-ui/icons/MarkEmailUnreadOutlined';
import MarkEmailRead from '@evaneos/b2b-ui/icons/MarkEmailReadOutlined';

type ToggleReadButtonProps = {
    isRead: boolean;
    onToggle: () => void;
    supportsHover: boolean;
};

export const ToggleReadButton = ({ isRead, onToggle, supportsHover }: ToggleReadButtonProps) => {
    const { formatMessage } = useIntl();

    return (
        <Box
            sx={{
                position: 'absolute',
                right: 24,
            }}
        >
            <Tooltip
                placement="top"
                disableInteractive
                title={
                    isRead
                        ? formatMessage({ id: 'homepage.notifications.mark_as_unread' })
                        : formatMessage({ id: 'homepage.notifications.mark_as_read' })
                }
                slotProps={{
                    popper: {
                        modifiers: [{ name: 'offset', options: { offset: [0, -10] } }],
                        sx: {
                            '&[data-popper-reference-hidden]': {
                                visibility: 'hidden',
                                'pointer-events': 'none',
                            },
                        },
                    },
                }}
            >
                <Button
                    data-toggle-read-status-btn
                    variant="outlined"
                    sx={{
                        p: 1,
                        minWidth: 0,
                        width: '40px',
                        height: '40px',
                        opacity: supportsHover ? { xs: 1, md: 0 } : 1,
                        transition: 'opacity 150ms ease',
                    }}
                    onClick={onToggle}
                    color="primary"
                >
                    {isRead ? (
                        <MarkEmailUnread
                            aria-hidden="true"
                            sx={{ width: 24, height: 24, color: paletteColors.neutral[900] }}
                        />
                    ) : (
                        <MarkEmailRead
                            aria-hidden="true"
                            sx={{ width: 24, height: 24, color: paletteColors.neutral[900] }}
                        />
                    )}
                </Button>
            </Tooltip>
        </Box>
    );
};
